import React from "react";
import { gradients } from "../../../utils/makeGradientColor";

export const makeColorInterfaceButton = (color, onClick) => {
  const isGradient = color.startsWith("Gradient");
  const style = {};

  if (isGradient) {
    const gradientName = color.replace("Gradient", "").toLowerCase();
    if (gradients[gradientName]) {
      style.background = gradients[gradientName].base;
      // Set CSS variables when clicking the button
      const handleClick = () => {
        Object.entries(gradients[gradientName].levels).forEach(
          ([level, value]) => {
            document.documentElement.style.setProperty(
              `--gradient-${level}`,
              value
            );
          }
        );
        onClick();
      };
      return (
        <li
          key={color}
          className="colorChoice"
          onClick={handleClick}
          style={style}
        />
      );
    }
  }

  return (
    <li
      key={color}
      className={`colorChoice colorInterface${color}`}
      onClick={onClick}
    />
  );
};
// Si je change d'avis au sujet des gradients, voici l'ancienne version de cette fonction
// import React from "react";
// export function makeColorInterfaceButton(color, onClickReceived) {
//   // Add debug logging
//   return (
//     <li
//       key={`colorInterface${color}`} // Add unique key
//       className={`selectable colorInterface${color}`}
//       style={{ width: "20px", height: "20px" }}
//       onClick={onClickReceived || (() => console.log(`Clicked ${color}`))} // Fallback if undefined
//     ></li>
//   );
// }



// WEBPACK FOOTER //
// ./src/components/Calcul Tools/Deducer Tools/makeColorInterfaceButton.js